<template>
  <div class="yindao">
    <div class="yindao_header">
      <p>填写基本信息</p>
      <p>完善基本信息，享受优质体验</p>
    </div>
    <van-form @failed="onFailed" @submit="onSubmit">
      <div class="section">
        <div class="section_title">个人信息</div>
        <van-field
          v-model="name"
          center
          name="name"
          label="姓名"
          placeholder="请输入您的姓名"
          :rules="[{ required: true, message: '请输入您的姓名' }]"
        />
        <van-field
          v-model="age"
          center
          disabled
          name="age"
          type="number"
          label="年龄"
          placeholder="请输入您的年龄"
        />
        <van-field
          readonly
          clickable
          v-model="birthday"
          center
          name="birthday"
          label="出生日期"
          placeholder="请选择您的出生日期"
          @click="showPicker = true"
          :rules="[{ required: true, message: '请选择您的出生日期' }]"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-datetime-picker
            type="date"
            title="选择出生日期"
            v-model="currentDate"
            :min-date="minDate"
            :max-date="maxDate"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          v-model="age"
          center
          readonly
          name="age"
          type="number"
          label="年龄"
          placeholder="请输入您的年龄"
        />
        <!-- <van-field
          v-model="professional"
          center
          name="professional"
          label="职业"
          placeholder="请输入您的职业"
          :rules="[{ required: true, message: '请输入您的职业' }]"
        /> -->
        <van-field
          v-model="tel"
          center
          name="tel"
          type="number"
          label="手机"
          placeholder="请输入您的手机"
          :rules="[{ validator, message: '请输入您的手机' }]"
        />
        <van-field
          v-model="code"
          center
          name="tel"
          maxlength="6"
          type="number"
          label="短信验证码"
          placeholder="请输入验证码"
        >
          <template #extra>
            <div
              :class="codeShow ? 'code_btn' : 'code_btn disabled'"
              @click="getcode"
            >
              {{ codeSpan }}
            </div>
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          name="picker"
          :value="src"
          label="信息来源"
          placeholder="请选择信息来源"
          @click="showPickerSrc = true"
          :rules="[{ required: true, message: '请选择您的信息来源' }]"
        />
        <van-popup v-model="showPickerSrc" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirmSrc"
            @cancel="showPickerSrc = false"
          />
        </van-popup>
      </div>
      <div class="section">
        <div class="section_title">想要咨询</div>
        <!-- <van-field name="plastic_project">
          <template #input>
            <van-tree-select
              :items="items"
              :active-id.sync="plastic_project"
              :main-active-index.sync="activeIndex"
            />
          </template>
        </van-field> -->
        <van-field name="checkboxGroup1">
          <template #input>
            <van-checkbox-group v-model="checkboxGroup1" direction="horizontal">
              <van-checkbox
                class="checkbox"
                checked-color="#ff410a"
                name="手术"
                shape="square"
                >手术</van-checkbox
              >
              <van-checkbox
                class="checkbox"
                checked-color="#ff410a"
                name="皮肤"
                shape="square"
                >皮肤</van-checkbox
              >
              <van-checkbox
                class="checkbox"
                checked-color="#ff410a"
                name="微整"
                shape="square"
                >微整</van-checkbox
              >
              <van-checkbox
                class="checkbox"
                checked-color="#ff410a"
                name="口腔"
                shape="square"
                >口腔</van-checkbox
              >
            </van-checkbox-group>
          </template>
        </van-field>
      </div>
      <!-- <div class="section">
        <div class="section_title">健康状况</div>
        <div class="section_box">
          <div class="section_item">
            <div class="item_title">1.您以前是否接受过手术或其他治疗</div>
            <van-field name="checkboxGroup1">
              <template #input>
                <van-checkbox-group
                  v-model="checkboxGroup1"
                  direction="horizontal"
                >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="植入心脏起搏器"
                    shape="square"
                    >植入心脏起搏器</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="金丝植入"
                    shape="square"
                    >金丝植入</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="填充"
                    shape="square"
                    >填充</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="无"
                    shape="square"
                    >无</van-checkbox
                  >
                </van-checkbox-group>
              </template>
            </van-field>
          </div>
          <div class="section_item">
            <div class="item_title">2.您是否有下列病史</div>
            <van-field name="checkboxGroup2">
              <template #input>
                <van-checkbox-group class="check_box" v-model="checkboxGroup2">
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="心脏病"
                    shape="square"
                    >心脏病</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="人造器官"
                    shape="square"
                    >人造器官</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="高血压"
                    shape="square"
                    >高血压</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="肝病"
                    shape="square"
                    >肝病</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="糖尿病"
                    shape="square"
                    >糖尿病</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="其他"
                    shape="square"
                    >其他</van-checkbox
                  >
                  <van-checkbox
                    class="checkbox"
                    checked-color="#ff410a"
                    name="无"
                    shape="square"
                    >无</van-checkbox
                  >
                </van-checkbox-group>
              </template>
            </van-field>
          </div>
          <div class="section_item">
            <div class="item_title">3.是否有药物过敏史</div>
            <van-field name="radio">
              <template #input>
                <van-radio-group v-model="radio" direction="horizontal">
                  <van-radio class="radio" checked-color="#ff410a" name="是"
                    >是</van-radio
                  >
                  <van-radio class="radio" checked-color="#ff410a" name="否"
                    >否</van-radio
                  >
                </van-radio-group>
              </template>
            </van-field>
          </div>
        </div>
      </div> -->
      <div style="margin: 16px 0;" v-if="subInfobtn">
        <van-button round block type="info" native-type="submit" color="#ff410a"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  Button,
  Form,
  Field,
  DatetimePicker,
  Popup,
  Toast,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  TreeSelect,
  Picker,
} from "vant";
import {
  postInformation,
  getVerifyCode,
  postVerifyCode,
} from "../../api/lcapi";
export default {
  name: "mianzheng_yindao",
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [Form.name]: Form,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [TreeSelect.name]: TreeSelect,
    [Picker.name]: Picker,
  },
  data() {
    return {
      subInfobtn: true,
      name: "", // 姓名
      age: "", // 年龄
      birthday: "", //生日
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      professional: "", // 职业
      tel: "", // 手机号
      code: "", // 验证码
      codeShow: true, // 验证码按钮状态
      codeSpan: "获取验证码",
      codetime: 300,
      showPicker: false, // 选择生日弹窗
      activeIds: [],
      activeIndex: 0,
      items: [
        // 项目
        {
          text: "整形外科",
          children: [
            {
              text: "眼部整形",
              id: "眼部整形",
            },
            {
              text: "鼻部整形",
              id: "鼻部整形",
            },
            {
              text: "胸部整形",
              id: "胸部整形",
            },
            {
              text: "吸脂塑形",
              id: "吸脂塑形",
            },
            {
              text: "脂肪移植",
              id: "脂肪移植",
            },
            {
              text: "面阔整形",
              id: "面阔整形",
            },
            {
              text: "整形其他",
              id: "整形其他",
            },
          ],
        },
        {
          text: "皮肤科",
          children: [
            {
              text: "脱毛治疗",
              id: "脱毛治疗",
            },
            {
              text: "痤疮",
              id: "痤疮",
            },
            {
              text: "皮肤其他",
              id: "皮肤其他",
            },
            {
              text: "纹绣",
              id: "纹绣",
            },
            {
              text: "肤质",
              id: "肤质",
            },
            {
              text: "特殊皮肤治疗",
              id: "特殊皮肤治疗",
            },
            {
              text: "肉毒素",
              id: "肉毒素",
            },
            {
              text: "玻尿酸",
              id: "玻尿酸",
            },
            {
              text: "仪器瘦身",
              id: "仪器瘦身",
            },
            {
              text: "其他项目",
              id: "其他项目",
            },
            {
              text: "悦怡",
              id: "悦怡",
            },
            {
              text: "肤色",
              id: "肤色",
            },
            {
              text: "仪器抗衰",
              id: "仪器抗衰",
            },
            {
              text: "中胚层",
              id: "中胚层",
            },
            {
              text: "敏感皮肤",
              id: "敏感皮肤",
            },
            {
              text: "水光",
              id: "水光",
            },
            {
              text: "补水",
              id: "补水",
            },
            {
              text: "私密",
              id: "私密",
            },
            {
              text: "SPA",
              id: "SPA",
            },
            {
              text: "抗衰",
              id: "抗衰",
            },
            {
              text: "皮肤管理",
              id: "皮肤管理",
            },
            {
              text: "基因检测",
              id: "基因检测",
            },
            {
              text: "皱纹",
              id: "皱纹",
            },
            {
              text: "仪器紧肤",
              id: "仪器紧肤",
            },
            {
              text: "祛痘",
              id: "祛痘",
            },
            {
              text: "美白嫩肤",
              id: "美白嫩肤",
            },
            {
              text: "雀斑",
              id: "雀斑",
            },
            {
              text: "黄褐斑",
              id: "黄褐斑",
            },
            {
              text: "终生卡",
              id: "终生卡",
            },
            {
              text: "敏感肌",
              id: "敏感肌",
            },
            {
              text: "痘印",
              id: "痘印",
            },
            {
              text: "痤疮+凹陷疤痕",
              id: "痤疮+凹陷疤痕",
            },
            {
              text: "黑眼圈+眼部年轻化",
              id: "黑眼圈+眼部年轻化",
            },
            {
              text: "面部紧致提升+年轻化",
              id: "面部紧致提升+年轻化",
            },
            {
              text: "眼部抗衰",
              id: "眼部抗衰",
            },
            {
              text: "面部抗衰",
              id: "面部抗衰",
            },
            {
              text: "颈纹",
              id: "颈纹",
            },
            {
              text: "脱毛",
              id: "脱毛",
            },
            {
              text: "产品",
              id: "产品",
            },
          ],
        },
        {
          text: "微整形",
          children: [
            {
              text: "botox",
              id: "botox",
            },
            {
              text: "衡力",
              id: "衡力",
            },
            {
              text: "线雕",
              id: "线雕",
            },
            {
              text: "瘢痕",
              id: "瘢痕",
            },
            {
              text: "抗衰老",
              id: "抗衰老",
            },
            {
              text: "玻尿酸",
              id: "玻尿酸",
            },
            {
              text: "溶脂塑形",
              id: "溶脂塑形",
            },
            {
              text: "嗨体",
              id: "嗨体",
            },
            {
              text: "其他项目",
              id: "其他项目",
            },
          ],
        },
        {
          text: "口腔科",
          children: [
            {
              text: "洁牙",
              id: "洁牙",
            },
            {
              text: "牙齿矫正",
              id: "牙齿矫正",
            },
            {
              text: "美容冠",
              id: "美容冠",
            },
            {
              text: "口腔其他",
              id: "口腔其他",
            },
          ],
        },
      ],
      src: "",
      columns: [
        "微信",
        "微博",
        "网络",
        "公交",
        "电梯",
        "地铁",
        "路过",
        "朋友介绍",
        "其他",
      ],
      showPickerSrc: false,
      checkboxGroup1: [],
      checkboxGroup2: [],
      plastic_project: [],
      radio: "",
      secret_key: "",
      timer: null,
      isSubmbit: true,
    };
  },
  mounted() {
    this.secret_key = this.$route.query.secret_key;
  },
  methods: {
    /**
     * 选择来源
     */
    onConfirmSrc(value) {
      this.src = value;
      this.showPickerSrc = false;
    },
    /**
     * 选择生日
     */
    onConfirm(date) {
      console.log(date);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      // return y + "-" + m + "-" + d + " " + h + ":" + minute;
      this.birthday = y + "年" + m + "月" + d + "日";
      var y2 = new Date().getFullYear();
      this.age = y2 - y;
      if (this.age == 0) {
        this.age = 1;
      }
      this.showPicker = false;
    },
    /**
     * 生日时间格式化
     */
    formatter(type, val) {
      if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    /**
     * 手机号验证
     */
    validator(val) {
      return /^1(3|4|5|7|8|9|6)\d{9}$/.test(val);
    },
    /**
     * 年龄验证
     */
    agerules(val) {
      return /^100$|^(\d|[1-9]\d)$/.test(val);
    },
    getcode() {
      const that = this;
      if (!that.codeShow) return;
      const tels = that.validator(that.tel);
      let key = "";
      if (tels) {
        getVerifyCode()
          .then((res) => {
            key = res.data.key;
            console.log(key);
            if (res.status == 200) {
              postVerifyCode({
                phone: that.tel,
                key: key,
              })
                .then((res) => {
                  that.codeShow = false;
                  that.codeSpan = that.codetime + " s";
                  let clock = window.setInterval(() => {
                    that.codetime--;
                    that.codeSpan = that.codetime + " s";
                    if (that.codetime < 0) {
                      that.codeSpan = "获取验证码";
                      that.codetime = 300;
                      that.codeShow = true;
                      window.clearInterval(clock);
                    }
                  }, 1000);
                  Toast({ message: res.msg });
                })
                .catch((err) => {
                  that.codeShow = false;
                  that.codeSpan = that.codetime + " s";
                  let clock = window.setInterval(() => {
                    that.codetime--;
                    that.codeSpan = that.codetime + " s";
                    if (that.codetime < 0) {
                      that.codeSpan = "获取验证码";
                      that.codetime = 300;
                      that.codeShow = true;
                      window.clearInterval(clock);
                    }
                  }, 1000);
                  Toast({ message: err.msg });
                });
            } else {
              Toast({ message: res.msg });
            }
          })
          .catch((err) => {
            Toast({ message: "获取验证码失败，请重新获取" });
          });
      } else {
        Toast({ message: "请输入正确的手机号" });
      }
    },
    /**
     * 提交信息
     */
    onSubmit(values) {
      console.log(this.checkboxGroup1);
      if (this.isSubmbit == false) {
        Toast({ message: "禁止重复提交" });
        return;
      }
      if (this.age <= 0) {
        Toast({ message: "请选择正确的出生日期" });
        return;
      }
      // if (this.plastic_project.length == 0) {
      //   Toast({ message: "请选择咨询项目" });
      //   return;
      // }
      if (this.code.length == 0) {
        Toast({ message: "请输入验证码" });
        return;
      }
      console.log(values);
      let health_condition = [
        {
          name: "您以前是否接受过手术或其他治疗",
          answer: JSON.stringify(this.checkboxGroup1)
            .replace(/\[|]/g, "")
            .replace(/\"/g, ""),
        },
        {
          name: "您是否有下列病史",
          answer: JSON.stringify(this.checkboxGroup2)
            .replace(/\[|]/g, "")
            .replace(/\"/g, ""),
        },
        {
          name: "您是否有药物过敏",
          answer: this.radio,
        },
      ];
      let data = {
        name: this.name,
        age: this.age,
        birthday: this.birthday,
        phone: this.tel,
        plastic_project: JSON.stringify(this.checkboxGroup1)
          .replace(/\[|]/g, "")
          .replace(/\"/g, ""),
        secret_key: this.secret_key,
        captcha: this.code,
        info_src: this.src,
      };
      postInformation(data)
        .then((res) => {
          // Toast({ message: res.msg });
          if (res.status == 200) {
            this.subInfobtn = false;
            this.isSubmbit = false;
            Toast({ message: "提交成功！" });
          } else {
            Toast({ message: res.msg });
          }
        })
        .catch((err) => {
          Toast({ message: err.msg || err });
        });
    },
    /**
     * 表单效验不通过
     */
    onFailed() {
      Toast({ message: "请正确填写信息" });
    },
  },
};
</script>

<style lang="scss" scoped>
.yindao {
  padding: 0 0.3rem 0.5rem 0.3rem;
  .yindao_header {
    margin-top: 0.7rem;

    p {
      &:first-child {
        font-size: 0.4rem;
        font-weight: bold;
      }
      &:last-child {
        margin-top: 0.23rem;
        font-size: 0.28rem;
        font-weight: 400;
      }
    }
  }
  .code_btn {
    background: #ff410a;
    text-align: center;
    color: #ffffff;
    height: 32px;
    line-height: 32px;
    font-size: 12px;
    width: 80px;
    &.disabled {
      background-color: #ddd;
      border-color: #ddd;
      color: #ff410a;
      cursor: not-allowed; // 鼠标变化
    }
  }
  .section {
    background: #ffffff;
    border-radius: 0.34rem;
    margin-top: 0.66rem;
    overflow: hidden;
    .section_title {
      font-size: 0.32rem;
      line-height: 1rem;
      padding-left: 10px;
      border-bottom: 0.01rem dashed #e9e9e9;
      position: relative;
      &::after {
        position: absolute;
        content: "";
        width: 0.3rem;
        height: 0.3rem;
        background: #f5f5f5;
        border-radius: 50%;
        bottom: 0;
        left: 0;
        transform: translate(-50%, 50%);
        z-index: 2000;
      }
      &::before {
        position: absolute;
        content: "";
        width: 0.3rem;
        height: 0.3rem;
        background: #f5f5f5;
        border-radius: 50%;
        bottom: 0;
        right: 0;
        transform: translate(50%, 50%);
        z-index: 2000;
      }
    }
    .section_ul {
      padding: 0 0.3rem 0.3rem 0.3rem;
      display: flex;
      flex-wrap: wrap;
      .section_item {
        margin-top: 0.2rem;
        margin-right: 0.2rem;
      }
      .section_li {
        padding: 0 0.2rem;
        height: 0.6rem;
        background: #fafafa;
        border: 0.01rem solid #e5e5e5;
        border-radius: 0.3rem;
        font-size: 0.28rem;
        text-align: center;
        line-height: 0.58rem;
        .van-checkbox__icon {
          height: 0;
        }
        &.active {
          background: rgba(255, 65, 10, 0.05);
          border: 0.01rem solid #ff410a;
          color: #ff410a;
        }
      }
    }
    .section_box {
      padding: 0.3rem;
      .item_title {
        font-size: 0.3rem;
        margin-top: 0.2rem;
      }
      .checkbox {
        margin-top: 0.2rem;
      }
      .check_box {
        display: flex;
        flex-wrap: wrap;
        .checkbox {
          width: 50%;
        }
      }

      .radio {
        margin-top: 0.2rem;
      }
    }
  }
  .submit_btn {
    height: 0.8rem;
    background: #ff410a;
    color: #fff;
    border-radius: 0.4rem;
    font-size: 0.32rem;
    color: #f7f7f7;
    text-align: center;
    line-height: 0.8rem;
    margin-top: 0.2rem;
  }
}
</style>

<style>
.van-picker__confirm {
  color: #ff410a;
}
.section_item .van-checkbox__icon {
  height: auto;
}
.getyzmBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;
}
.getyzmSpan {
  display: block;
  width: 1.4rem;
  padding: 0.2rem 0.4rem;
  background: #000;
  color: #fff;
  border-radius: 0.8rem;
  font-size: 0.24rem;
}

.van-tree-select {
  flex: 1;
}
</style>
